import { addDays, isAfter, isBefore, isWithinInterval, subSeconds } from 'date-fns';
import { isDateOnlyYMD } from './dates';

export const MIN_DATE = new Date(1900, 0, 1);
export const MAX_DATE = new Date(2099, 11, 31);

export class Intervals {
  static isNowWithinInterval(start: Date | string, end: Date | string) {
    const startDate = start ? new Date(start) : MIN_DATE;
    const endDate = end ? new Date(end) : MAX_DATE;

    const endDateFormat =
      typeof end === 'string' && isDateOnlyYMD(end) ? subSeconds(addDays(endDate, 1), 1) : endDate;

    if (isAfter(startDate, endDateFormat)) {
      return false;
    }

    return isWithinInterval(new Date(), { start: startDate, end: endDateFormat });
  }

  static isNowBefore(date: Date | string) {
    return isBefore(new Date(), date ? new Date(date) : MAX_DATE);
  }

  static isNowAfter(date: Date | string) {
    return isAfter(new Date(), date ? new Date(date) : MIN_DATE);
  }
}
